window.Products.Clothing.ComfortLongSleeveTShirt = function() {
};
window.Products.Clothing.ComfortLongSleeveTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ComfortLongSleeveTShirt.dpi = 150;
window.Products.Clothing.ComfortLongSleeveTShirt.has_3d = true;
window.Products.Clothing.ComfortLongSleeveTShirt.id = 104;
window.Products.Clothing.ComfortLongSleeveTShirt.slug = 'comfort-long-sleeve-t-shirt';
window.Products.Clothing.ComfortLongSleeveTShirt.syncColors = true;
window.Products.Clothing.ComfortLongSleeveTShirt.texturesLoaded = 0;
window.Products.Clothing.ComfortLongSleeveTShirt.texturesLoading = false;
window.Products.Clothing.ComfortLongSleeveTShirt.use_glb = true;

window.Products.Clothing.ComfortLongSleeveTShirt.prototype.outsideObject = 0;
window.Products.Clothing.ComfortLongSleeveTShirt.prototype.detailsObject = 1;
window.Products.Clothing.ComfortLongSleeveTShirt.prototype.position = 0.1;

window.Products.Clothing.ComfortLongSleeveTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey" || color == "charcoal"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ComfortLongSleeveTShirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"carolina_blue": 0x7ba2db,
		"garnet": 0x84172a,
		"gold": 0xdf9f3b,
		"irish_green": 0x15af71,
		"navy": 0x2b2e3f,
		"purple": 0x443169,
		"royal": 0x39579d,
		"safety_orange": 0xff8000,
		"safety_green": 0xe5ed4c,
		"sport_grey": 0xbababa,
		"red": 0xa2393c,
		"charcoal": 0x393336,
	};

	return new THREE.Color(colors[_name]);
};